const Clock = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M11.9996 22.8996C18.0195 22.8996 22.8996 18.0195 22.8996 11.9996C22.8996 5.97971 18.0195 1.09961 11.9996 1.09961C5.97971 1.09961 1.09961 5.97971 1.09961 11.9996C1.09961 18.0195 5.97971 22.8996 11.9996 22.8996Z"
        fill="#4D4841"
      />
      <path
        d="M11.9996 20.3996C16.6388 20.3996 20.3996 16.6388 20.3996 11.9996C20.3996 7.36042 16.6388 3.59961 11.9996 3.59961C7.36042 3.59961 3.59961 7.36042 3.59961 11.9996C3.59961 16.6388 7.36042 20.3996 11.9996 20.3996Z"
        fill="#FEFBF9"
      />
      <path
        d="M3.59961 11.9996C3.59961 9.77179 4.48461 7.63522 6.05991 6.05991C7.63522 4.48461 9.77179 3.59961 11.9996 3.59961C14.2274 3.59961 16.364 4.48461 17.9393 6.05991C19.5146 7.63522 20.3996 9.77179 20.3996 11.9996H3.59961Z"
        fill="#EBE4DC"
      />
      <path
        d="M12.4002 4.40039H11.6002C11.3793 4.40039 11.2002 4.57948 11.2002 4.80039V5.60039C11.2002 5.8213 11.3793 6.00039 11.6002 6.00039H12.4002C12.6211 6.00039 12.8002 5.8213 12.8002 5.60039V4.80039C12.8002 4.57948 12.6211 4.40039 12.4002 4.40039Z"
        fill="#474646"
      />
      <path
        d="M19.5996 12.4002V11.6002C19.5996 11.3793 19.4205 11.2002 19.1996 11.2002H18.3996C18.1787 11.2002 17.9996 11.3793 17.9996 11.6002V12.4002C17.9996 12.6211 18.1787 12.8002 18.3996 12.8002H19.1996C19.4205 12.8002 19.5996 12.6211 19.5996 12.4002Z"
        fill="#474646"
      />
      <path
        d="M11.5998 19.5996H12.3998C12.6207 19.5996 12.7998 19.4205 12.7998 19.1996V18.3996C12.7998 18.1787 12.6207 17.9996 12.3998 17.9996H11.5998C11.3789 17.9996 11.1998 18.1787 11.1998 18.3996V19.1996C11.1998 19.4205 11.3789 19.5996 11.5998 19.5996Z"
        fill="#474646"
      />
      <path
        d="M4.40039 11.5998V12.3998C4.40039 12.6207 4.57948 12.7998 4.80039 12.7998H5.60039C5.8213 12.7998 6.00039 12.6207 6.00039 12.3998V11.5998C6.00039 11.3789 5.8213 11.1998 5.60039 11.1998H4.80039C4.57948 11.1998 4.40039 11.3789 4.40039 11.5998Z"
        fill="#474646"
      />
      <path
        d="M8.5895 9.10713C8.20687 8.88622 7.71759 9.01732 7.49668 9.39995C7.27577 9.78259 7.40687 10.2719 7.7895 10.4928L10.9072 12.2928C11.2898 12.5137 11.7791 12.3826 12 12C12.2209 11.6173 12.0898 11.128 11.7072 10.9071L8.5895 9.10713Z"
        fill="#474646"
      />
      <path
        d="M18.0159 9.22009C18.3029 9.0544 18.4012 8.68745 18.2355 8.40047C18.0699 8.1135 17.7029 8.01517 17.4159 8.18086L12.2198 11.1809C11.9328 11.3465 11.8345 11.7135 12.0002 12.0005C12.1658 12.2875 12.5328 12.3858 12.8198 12.2201L18.0159 9.22009Z"
        fill="#474646"
      />
      <path
        d="M11.9998 13.1998C12.6625 13.1998 13.1998 12.6625 13.1998 11.9998C13.1998 11.3371 12.6625 10.7998 11.9998 10.7998C11.3371 10.7998 10.7998 11.3371 10.7998 11.9998C10.7998 12.6625 11.3371 13.1998 11.9998 13.1998Z"
        fill="#F06767"
      />
    </svg>
  );
};

export default Clock;
